import React from 'react'

const Solution = () => {
  return (
    <>
      {/* first section */}
      <section className="ax-solution-first-sec-main">
        <div className="ax-solution-first-sec-circle">
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 173 173" fill="none">
            <circle cx="86.5" cy="86.5" r="86.5" fill="url(#ax_paint_radial)" />
            <defs>
              <radialGradient id="ax_paint_radial" cx={0} cy={0} r={1} gradientUnits="userSpaceOnUse" gradientTransform="translate(86.5 86.5) rotate(90) scale(86.5)">
                <stop stopColor="#F73400" />
                <stop offset={1} stopColor="#36E3BF" />
              </radialGradient>
            </defs>
          </svg>
        </div>
        <div className="ax-solution-first-sec-jumble-container">
          <div className="ax-solution-first-sec-row">
            <h3 className="ax-solution-first-sec-text">Kickstart</h3>
          </div>
          <div className="ax-solution-first-sec-row">
            <h3 className="ax-solution-first-sec-words">
              <span className="ax-solution-first-sec-word-your">Your</span>
              <span className="ax-solution-first-sec-letter">STORE</span>
            </h3>
          </div>
          <div className="ax-solution-first-sec-row">
            <h3 className="ax-solution-first-sec-text">
              With <span className="ax-solution-first-sec-us">US</span>
            </h3>
          </div>
        </div>
      </section>
      {/* second section */}
      <section className="ax-solut-seond-sec-main">
        <div className="ax-solut-seond-sec-bg-shape-orange" />
        <img src="/assets/images/star.png" alt="Star Decor" className="ax-solut-seond-sec-star-element" />
        <div className="ax-solut-seond-sec-container container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="ax-solut-seond-sec-main-heading display-3">
                <span className="custom-end-to-end">END-TO-END</span><br />
                <span className="ax-solut-seond-sec-cursive-text">Solutions</span>
                <span style={{}}>Offered</span>
              </h1>
            </div>
            <div className="col-lg-6 d-flex justify-content-lg-end justify-content-center">
              <div className="ax-solut-seond-sec-content-card">
                <div className="mb-3" style={{ fontSize: '2rem' }}>✦</div>
                <p className="lead custom-e-commerce-text" style={{ fontWeight: 300, lineHeight: '1.6' }}>
                  E-commerce business frequently changes day by day. All you need
                  is a platform that will make your work
                  <strong style={{ color: '#40e0d0' }}>time-saving and very easy!</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* third section */}
      <section className="ax-solution-third-sect-main" id="Design">
        <div className="ax-solution-third-sect-nav-wrapper">
          <ul className="ax-solution-third-sect-nav">
            <li>
              <a href="#Design" style={{ background: 'linear-gradient(90deg, #f73400 0%, #121212 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Design</a>
            </li>
            <li><a href="#Development">Development</a></li>
            <li><a href="#Marketing">Marketing</a></li>
            <li><a href="#Management">Management</a></li>
          </ul>
        </div>
        <div className="ax-solution-third-sect-row">
          <div className="ax-solution-third-sect-col">
            <h1 className="text-white custom-templt-sec">Templates &amp; Logos</h1>
            <p className="text-white fs-4">
              Are you looking to establish your brand identity online? Creating a
              unique logo and designing a captivating website template can make
              all the difference in attracting customers and converting them into
              loyal buyers.
            </p>
          </div>
          <div className="ax-solution-third-sect-col">
            <div className="ax-solution-third-sect-marquee-container">
              <div className="ax-solution-third-sect-marquee-content">
                <img src="/assets/images/img3x2.webp" alt="Img 1" />
                <img src="/assets/images/img3x3.webp" alt="Img 2" />
                <img src="/assets/images/img3x4.webp" alt="Img 3" />
                <img src="/assets/images/img3x2.webp" alt="Img 1" />
                <img src="/assets/images/img3x3.webp" alt="Img 2" />
                <img src="/assets/images/img3x4.webp" alt="Img 3" />
              </div>
            </div>
          </div>
        </div>
        <div className="ax-solution-third-sect-row">
          <div className="ax-solution-third-sect-col">
            <div className="ax-solution-third-sect-marquee-container">
              <div className="ax-solution-third-sect-marquee-content">
                <img src="/assets/images/img3x2.webp" alt="Img 1" />
                <img src="/assets/images/img3x3.webp" alt="Img 2" />
                <img src="/assets/images/img3x4.webp" alt="Img 3" />
                <img src="/assets/images/img3x2.webp" alt="Img 1" />
                <img src="/assets/images/img3x3.webp" alt="Img 2" />
                <img src="/assets/images/img3x4.webp" alt="Img 3" />
              </div>
            </div>
          </div>
          <div className="ax-solution-third-sect-col">
            <h1 className="text-white custom-templt-sec">Fully Responsive Designs</h1>
            <p className="text-white fs-4">
              The digital landscape is ever-evolving, and mobile devices have
              become the primary means for accessing information online.
              Therefore, prioritizing responsiveness in your web design strategy
              cannot be overstated.
            </p>
          </div>
        </div>
        <div className="ax-solution-third-sect-row ax-solution-third-sect-row-reverse">
          <div className="ax-solution-third-sect-col">
            <div className="ax-solution-third-sect-video-box">
              <video autoPlay muted loop playsInline>
                <source src="/assets/images/video3x3.mp4" type="video/mp4" />
              </video>
            </div>
          </div>
          <div className="ax-solution-third-sect-col">
            <h1 className="text-white custom-templt-sec">Interactive Designs</h1>
            <p className="text-white fs-4">
              As technology advances rapidly, modern eCommerce websites demand
              more than merely attractive templates and logos; they require
              compelling interactive design features to engage visitors and boost
              sales.
            </p>
          </div>
        </div>
      </section>


      {/* fourth-section */}
      <section className="ax-solution-fourth-sec-main" id="Development">
        <div className="ax-solution-fourth-sec-overflow">
          <p className="ax-solution-fourth-sec-text">
            &lt;!DOCTYPE html&gt;<br />
            &lt;html lang="en"&gt;<br /><br />
            &lt;head&gt;<br />
            &lt;meta charset="UTF-8"&gt;<br />
            &lt;meta name="viewport" content="width=device-width,
            initial-scale=1.0"&gt;<br />
            &lt;link rel="stylesheet" href="style.css"&gt;<br />
            &lt;link rel="stylesheet" href="javascript.js"&gt;<br />
            &lt;link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
            rel="stylesheet"&gt;<br />
            &lt;script
            src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js"&gt;&lt;/script&gt;<br />
            &lt;link rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css"&gt;<br /><br />
            &lt;title&gt;Axesell&lt;/title&gt;<br />
            &lt;/head&gt;<br /><br />
            &lt;body&gt;<br />
            &lt;header&gt;<br /><br />
            &lt;nav class="navbar navbar-expand-lg"&gt;<br />
            &lt;div class="container-fluid"&gt;<br />
            &lt;a class="navbar-brand" href="#"&gt;<br />
            &lt;img src="images/logo.png" alt="AxeSell Logo" width="60"
            height="60"&gt;<br />
            &lt;/a&gt;<br />
            &lt;button class="navbar-toggler" type="button"
            data-bs-toggle="collapse" data-bs-target="#navbarNav"&gt;<br />
            &lt;span class="navbar-toggler-icon"&gt;&lt;/span&gt;<br />
            &lt;/button&gt;<br />
            &lt;div class="collapse navbar-collapse justify-content-center "
            id="navbarNav"&gt;<br />
            &lt;ul class=" d-flex gap-4 navbar-nav "&gt;<br />
            &lt;li class="nav-item dropdown"&gt;<br />
            &lt;a class="nav-link dropdown-toggle" href="#"
            id="solutionsDropdown"&gt;<br />
            Solutions<br />
            &lt;/a&gt;<br />
            &lt;ul class="dropdown-menu "&gt;<br />
            &lt;li&gt;&lt;a class="dropdown-item text-white" href="#"&gt;Solution
            1&lt;/a&gt;&lt;/li&gt;<br />
            &lt;li&gt;&lt;a class="dropdown-item text-white" href="#"&gt;Solution
            2&lt;/a&gt;&lt;/li&gt;<br />
            &lt;li&gt;&lt;a class="dropdown-item text-white" href="#"&gt;Solution
            3&lt;/a&gt;&lt;/li&gt;<br />
            &lt;/ul&gt;<br />
            &lt;/li&gt;
          </p>
        </div>
      </section>
      {/* fifth sewction */}
      <section className="ax-solution-fifth-sec-main container"   id="Marketing">
        <div className="ax-solution-fifth-sec-rectangle">
          <h2 className="ax-solution-fifth-sec-title">Front-End Framework</h2>
          <p className="ax-solution-fifth-sec-text">
            HTML5 provides the framework for structuring content on webpages while
            CSS3 adds style and elegance to elements' appearance. Combining these
            two technologies creates responsive layouts that adapt to varied
            screens sizes and devices, improving user experience greatly.
          </p>
        </div>
      </section>
      {/* six section */}
      <section className>
        <div className="container-fluid">
          <div className="row ax-six-solution-six-sec-main">
            <div className="col-md-6 ax-six-solution-six-sec-con">
              <h3 className="ax-six-solution-six-sec-title">Back-End Framework</h3>
              <p className="ax-six-solution-six-sec-text">
                HTML5 provides the framework for structuring content on webpages while
                CSS3 adds style and elegance to elements' appearance. Combining these
                two technologies creates responsive layouts that adapt to varied
                screens sizes and devices, improving user experience greatly.
              </p>
            </div>
            <div className="col-md-6">
              <img src="/assets/images/img9x2.png" alt="Back-End Illustration" className="ax-six-solution-six-sec-img" />
            </div>
          </div>
        </div>
      </section>
     
      {/* eleven section */}
      <section className="ax-solution-eleven-sec-main" id="Management">
        <div className="container">
          <div className="ax-solution-eleven-sec-headings">
            <h1>System Management Features</h1>
          </div>
        </div>
        <div className="ax-solution-eleven-sec-video-wrap">
          <video autoPlay muted loop playsInline>
            <source src="/assets/images/video11x1.mp4" type="video/mp4" />
          </video>
        </div>
        <div className="container">
          <div className="row ax-solution-eleven-sec-feature-row">
            <div className="col-md-4 ax-solution-eleven-sec-col">
              <h4>User Management</h4>
              <p>
                Activate or deactivate profiles using user management features.
                Dashboard which will display all essential features to manage
                effectively.
              </p>
            </div>
            <div className="col-md-4 ax-solution-eleven-sec-col">
              <h4>Order Management</h4>
              <p>
                Manage your cancelled, delivered, or exchanged orders. Track
                customer orders and make sure if the right orders are delivered.
              </p>
            </div>
            <div className="col-md-4 ax-solution-eleven-sec-col">
              <h4>Product Management</h4>
              <p>
                Active/Inactive products can be managed effectively. Stock
                management, bulk product upload, updates, and additions.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div>
        {/* feature section */}
        <div className="ax-solution-featur-sec-headings container">
          <h1>Features For Your Customers</h1>
        </div>
        <section className="ax-solution-featur-sec-main">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-7 ax-solution-featur-sec-video-box">
                <video autoPlay muted loop playsInline>
                  <source src="/assets/images/video12x1.mp4" type="video/mp4" />
                </video>
              </div>
              <div className="col-md-5 d-flex flex-column justify-content-center ax-solution-featur-sec-info-col">
                <div className>
                  <h4>Account Controls</h4>
                  <p>
                    The user can control their account with ease. Changing password,
                    saving to wishlist or editing profile details can be done via
                    their dashboard.
                  </p>
                </div>
                <div className>
                  <h4>Order Support</h4>
                  <p>
                    Order tracking, delivery order list, cancelled order list, order
                    number, and direct order all supported on the platform.
                  </p>
                </div>
                <div>
                  <h4>Security &amp; Privacy</h4>
                  <p>
                    All user data is secure with us and we have provide multiple
                    features like secure transactions to make sure of that.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="ax-solution-service-sec-main">
          <div className="container">
            <div className="ax-solution-service-sec-title-wrap">
              <span className="ax-solution-service-sec-title-top">
                <span className="rotate-s">W</span>hat We Offer
              </span>
              <span className="ax-solution-service-sec-title-mid">Our</span>
              <span className="ax-solution-service-sec-title-bottom">FEATURES</span>
            </div>
            <div className="ax-solution-service-sec-list">
              {/* Store Front */}
              <details className="ax-solution-service-sec-item">
                <summary className="ax-solution-service-sec-summary">
                  STORE FRONT
                  <div className="ax-solution-service-sec-arrow" />
                </summary>
                <div className="ax-solution-service-sec-content">
                  We have closely developed the store front to have maximum ability to serve best to your users.
                  <ul>
                    <li>Unlimited Products Upload</li>
                    <li>Email &amp; SMS Notifications</li>
                    <li>Transfer Money from orders directly to your bank</li>
                    <li>Great Support system for users</li>
                  </ul>
                </div>
              </details>
              {/* Admin Panel */}
              <details className="ax-solution-service-sec-item">
                <summary className="ax-solution-service-sec-summary">
                  ADMINISTRATOR PANEL
                  <div className="ax-solution-service-sec-arrow" />
                </summary>
                <div className="ax-solution-service-sec-content">
                  We have closely developed the admin panel to give you full control over your business operations.
                  <ul>
                    <li>Manage products, categories &amp; inventory easily</li>
                    <li>Track orders, payments &amp; customer activity</li>
                    <li>Advanced analytics and reports</li>
                    <li>Complete control over store settings</li>
                  </ul>
                </div>
              </details>
              {/* Extra (optional but recommended for UI balance) */}
              <details className="ax-solution-service-sec-item">
                <summary className="ax-solution-service-sec-summary">
                  CUSTOMER EXPERIENCE
                  <div className="ax-solution-service-sec-arrow" />
                </summary>
                <div className="ax-solution-service-sec-content">
                  Designed to provide a smooth and engaging experience for your users.
                  <ul>
                    <li>Fast and responsive UI</li>
                    <li>Easy checkout process</li>
                    <li>Mobile optimized design</li>
                    <li>User-friendly navigation</li>
                  </ul>
                </div>
              </details>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default Solution